import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Home from './components/Home';
import About from './components/whatIsAiExpo';
import WhosThisFor from './components/whoseThisFor';
import KeyDates from './components/keyDates';
import Partners from './components/Partners';
import Footer from './components/Footer';

function App() {
  const location = useLocation();

  /* Handle hash-based navigation for smooth scroll to elements. */
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const target = document.getElementById(id);
      if (target) {
        const headerHeight = document.querySelector('.header')?.offsetHeight || 100;
        const topOffset = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({ top: topOffset, behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <div className="App">
      <Header />
      <main>
        <Home />
        <About />
        <WhosThisFor />
        <KeyDates />
        <Partners />
      </main>
      <Footer />
    </div>
  );
}

export default App;
